import { ADD_TRIGER, DELETE_TRIGGER, GET_SINGLE_TRIGGER,DRAG_DATA,DRAG_SAMPLE_DATA, EDIT_TRIGGER, EDIT_SAMPLE_TRIGGER,DELETE_SAMPLE_TRIGGER,GET_SAMPLE_TRIGGER_DATA } from "../actions/types"

const initialState = {
    data: [],
    guide: [],
    category: []
}

export default function (state = initialState, action) {
    switch (action.type) {
        case ADD_TRIGER:
            return {
                ...state,
                data: action.payload
            };
        case DELETE_TRIGGER:
            return {
                ...state,
                data: action.payload
            }
            case DELETE_SAMPLE_TRIGGER:
                return {
                    ...state,
                    data: action.payload
                }
            
        case GET_SINGLE_TRIGGER:
            return {
                ...state,
                plan: action.payload
            };
            case GET_SAMPLE_TRIGGER_DATA:
            return {
                ...state,
                data: action.payload
            };
        case EDIT_TRIGGER:
            return {
                ...state
            };
            case EDIT_SAMPLE_TRIGGER:
            return {
                ...state
            };
            case DRAG_DATA:
                return{
                    ...state
                }
            case DRAG_SAMPLE_DATA:
                return{
                    ...state
                }

        default:
            return state
    }
}